import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faShieldCheck, faShieldExclamation, faShieldXmark } from '@fortawesome/pro-light-svg-icons'

interface Status {
  icon: IconProp
  color: string
  label: string
}

export const STATUSES: Record<string, Status> = {
  protected: {
    icon: faShieldCheck as IconProp,
    color: 'rgba(35, 120, 4, 1)',
    label: 'protected',
  },
  monitoringOnly: {
    icon: faShieldExclamation as IconProp,
    color: 'rgba(255, 187, 150, 1)',
    label: 'monitoringOnly',
  },
  notProtected: {
    icon: faShieldXmark as IconProp,
    color: 'rgba(207, 19, 34, 1)',
    label: 'notProtected',
  },
  notConnected: {
    icon: faShieldXmark as IconProp,
    color: '#FFA39E',
    label: 'notConnected',
  },
  wordpressNotRecognized: {
    icon: faShieldExclamation as IconProp,
    color: 'rgb(255, 153, 0)',
    label: 'wordpressNotRecognized',
  },
}
